import styled from "styled-components";
import { PRIMARY, SECONDARY } from "../../const/colors";

export const ContainerModal = styled.div`
  background-color: #fff;
	border: 1px solid ${PRIMARY};
  width: 80vw;

   /* h2, div[data-qid='cipSection']:nth-child(2), div#form > div > div > span {
    color: #fff;
  } */
`;